


/*20/5/2025
import wixLocation from 'wix-location';

const currentUrl = wixLocation.url; // Get the current URL
const phoneNumber = '85260201162';
const message = `你好！我想查詢一下鏈結產品資訊：\n${currentUrl}`;
const encodedMessage = encodeURIComponent(message);
        const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

$w("#image39").link = whatsappLink;
$w("#image39").target = "_blank";






*/
/*
import { myGetCurrentCartFunction } from "backend/currentcart.web";

myGetCurrentCartFunction()
  .then((myCurrentCart) => {
    const formattedCartTotal = myCurrentCart.subtotal.formattedAmount;
    const numberOfCartLineItems = myCurrentCart.lineItems.length;

    console.log("Success! Retrieved current cart:", myCurrentCart);
    return myCurrentCart;
  })
  .catch((error) => {
    console.error(error);
    // Handle the error
  });



myGetCurrentCartFunction()
  .then((myCurrentCart) => {
    // Get the URL of the first item in the cart
    const firstItemUrl = myCurrentCart.lineItems[0]?.url;

    console.log("Product URL:", firstItemUrl); // e.g., "https://example.wixsite.com/product-page"
    return firstItemUrl; // Return the URL if needed
  })
  .catch((error) => {
    console.error("Error fetching cart:", error);
  });


*/

/*
$w.onReady(function () {
    $w("#image39").onClick(() => {
        const currentUrl = wixLocation.url; // Get the current URL
        const phoneNumber = '85260201162';

        // Create the message with newline characters
        const message = `你好！我想查詢一下鏈結產品資訊：\n${currentUrl}`;

        // Encode the message to ensure it's formatted correctly for the URL
        const encodedMessage = encodeURIComponent(message);

        // Construct the WhatsApp link
        const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

        // Navigate to the WhatsApp link
        wixLocation.to(whatsappLink);
    });
});


*/

/*

import { currentCart } from "wix-ecom-backend";



import wixLocation from 'wix-location';
import wixStores from 'wix-stores';

const currentUrl = wixLocation.url;
const phoneNumber = '85260201162';

async function generateWhatsAppMessage() {
    const isCartPage = currentUrl.includes('/cart'); // Adjust if needed
    
    if (isCartPage) {
        try {
            const cart = await wixStores.getCurrentCart();
            
            // Fetch product details and URLs for all cart items
            const productDetails = await Promise.all(
                cart.lineItems.map(async (item) => {
                    const product = await currentCart.lineitems(item.productId);
                    return {
                        name: product.name,
                        url: product.productPageUrl.base + product.productPageUrl.path // Full URL
                    };
                })
            );
            
            // Format message with product names + URLs
            const productList = productDetails.map(
                item => `- ${item.name}: ${item.url}`
            ).join("\n");
            
            return `你好！我想查詢購物車內的產品：\n${productList}\n\n（來自連結：${currentUrl}）`;
        } catch (error) {
            console.error("Error fetching cart products:", error);
            return `你好！我想查詢一下鏈結產品資訊：\n${currentUrl}`; // Fallback
        }
    } else {
        return `你好！我想查詢一下鏈結產品資訊：\n${currentUrl}`;
    }
}

async function updateWhatsAppLink() {
    const message = await generateWhatsAppMessage();
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    $w("#image39").link = whatsappLink;
    $w("#image39").target = "_blank";
}

$w.onReady(updateWhatsAppLink);

*/






/*
import { myGetCurrentCartFunction } from "backend/currentcart.web";

myGetCurrentCartFunction()
  .then((myCurrentCart) => {
    const formattedCartTotal = myCurrentCart.subtotal.formattedAmount;
    const numberOfCartLineItems = myCurrentCart.lineItems.length;

    console.log("Success! Retrieved current cart:", myCurrentCart);
    return myCurrentCart;
  })
  .catch((error) => {
    console.error(error);
    // Handle the error
  });



myGetCurrentCartFunction()
  .then((myCurrentCart) => {
    // Get the URL of the first item in the cart
    const firstItemUrl = myCurrentCart.lineItems[0]?.url;
const allProductUrls = myCurrentCart.lineItems.map(item => item.url);
console.log("All product URLs:", allProductUrls);
    console.log("Product URL:", firstItemUrl); // e.g., "https://example.wixsite.com/product-page"
    return firstItemUrl; // Return the URL if needed
  })
  .catch((error) => {
    console.error("Error fetching cart:", error);
  });




import wixLocation from 'wix-location';
import wixStores from 'wix-stores'; // Required for cart access

const currentUrl = wixLocation.url;
const phoneNumber = '85260201162';

// Function to generate WhatsApp message based on page
async function generateWhatsAppMessage() {
    const isCartPage = currentUrl.includes('/cart'); // Adjust if your cart page has a different path
    
    if (isCartPage) {
        try {
            const cart = await wixStores.getCurrentCart();
            const productNames = cart.lineItems.map(item => item.product.name).join(", ");
            
            return `你好！我想查詢購物車內的產品：\n${productNames}\n\n（來自連結：${currentUrl}）`;
        } catch (error) {
            console.error("Failed to fetch cart items:", error);
            return `你好！我想查詢一下鏈結產品資訊：\n${currentUrl}`; // Fallback message
        }
    } else {
        return `你好！我想查詢一下鏈結產品資訊：\n${currentUrl}`; // Default message for non-cart pages
    }
}

// Update the image link dynamically
async function updateWhatsAppLink() {
    const message = await generateWhatsAppMessage();
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    $w("#image39").link = whatsappLink;
    $w("#image39").target = "_blank";
}

// Run the function when the page loads
$w.onReady(updateWhatsAppLink);
*/









import wixLocation from 'wix-location';
import wixStores from 'wix-stores';
import { myGetCurrentCartFunction } from "backend/currentcart.web";

const currentUrl = wixLocation.url;
const phoneNumber = '85260201162';

async function generateWhatsAppMessage() {
    const isCartPage = currentUrl.includes('/cart');
            const isthankPage = currentUrl.includes('/thank-you-page');

    if (isCartPage) {
        try {
            // Using the backend function to get full cart details including URLs
            const cart = await myGetCurrentCartFunction();
            
            // Create product details with names and URLs
            const productDetails = cart.lineItems.map(item => 
                `- ${item.quantity || 'quantity'}件 ${item.productName?.original || 'Product'}: \n${item.url || 'No URL available'}`
            ).join("\n");
            
            return `你好！我即將完成網上結賬，想確認以下購物車內的產品：\n請問今天或明天可以安排送貨嗎？\n\n${productDetails}\n`;
        } catch (error) {
            console.error("Failed to fetch cart items:", error);
            return `你好！我想查詢一下鏈結產品資訊：\n${currentUrl}`;
        }
    } else if (isthankPage){
        return `你好！我剛剛下了單！`;
    }else {
        return `你好！我想查詢一下鏈結產品資訊：\n${currentUrl}`;
    }
}

async function updateWhatsAppLink() {
    const message = await generateWhatsAppMessage();
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    $w("#image39").link = whatsappLink;
    $w("#image39").target = "_blank";
}

$w.onReady(updateWhatsAppLink);